export interface IMenu { }
